export interface IMenu { }
